module.exports = __webpack_public_path__ + "static/img/38745v.321c100.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/38745v.jpg
// module id = OgBk
// module chunks = 1